<template>
	<main-page :user="user" color="blue">
		<template v-slot:title>
			<template> TVR FEEDBACK </template>
		</template>

		<div>
			<div class="row content justify-content-center" v-if="rubric">
				<h1 v-if="recipient" class="mt-4 si-font">Feedback for {{fs.displayName(recipient.name)}}</h1>
				<div v-if="anyFeedbacks" class="col-12">
					<div class="mx-auto d-flex flex-column" style="max-width: 500px">
						<template v-for="(cat, i) in rubric.categories">
							<div :key="cat.id">
								<h1 class="mt-4 si-font" :class="{ [`si-text-${getColor(i)}`]: true }">
									{{ cat.name }}
								</h1>
								<div class="card mt-2 w-100 black-border">
									<template v-if="anyFeedbacks">
										<table v-if="studentMode">
											<tr>
												<td colspan="2" class="text-left pl-3 text-md">My Assessment</td>
											</tr>
											<tr v-if="cat.ownFeedback">
												<td class="score-cell b-t b-r">{{ cat.ownFeedback.score }}</td>
												<td class="text-cell b-t text-left py-2 px-3">
													{{ cat.ownFeedback.text }}
												</td>
											</tr>
											<tr v-else>
												<td colspan="2" class="text-very-muted text-center text-lg">None</td>
											</tr>
											<tr>
												<td colspan="2" class="text-left pl-3 text-md">
													Teammates' Assessments
												</td>
											</tr>
											<tr v-for="(f, i) in cat.otherFeedbacks" :key="i">
												<td class="score-cell b-t b-r">{{ f.score }}</td>
												<td class="text-cell b-t text-left py-2 px-3">{{ f.text }}</td>
											</tr>
											<tr v-if="!(cat.otherFeedbacks && cat.otherFeedbacks)">
												<td colspan="2" class="text-very-muted text-center text-lg">None</td>
											</tr>
										</table>
										<table v-else>
											<template>
											<tr>
													<td colspan="2" class="text-left pl-3 text-md">
														<span :class="{ [`si-text-${getColor(i)}`]: true }"
															>{{
																recipient
																	? fs.displayName(recipient.name)
																	: "(Unknown)"
															}}'s</span
														>
														Self-Assessment
														<button
															v-if="user.role == 'TEACHER'"
															class="mt-1 btn btn-no-border btn-si-icon float-right"
															v-tippy
															title="Delete"
														>
															<i class="fas fa-trash" @click="openDeleteModal(cat.ownFeedback)" />
														</button>
													</td>
											</tr>
											<tr v-if="cat.ownFeedback">
												<td class="score-cell b-t b-r">{{ cat.ownFeedback.score }}</td>
												<td class="text-cell b-t text-left py-2 px-3">
													{{ cat.ownFeedback.text }}
												</td>
											</tr>
											<tr v-else>
												<td colspan="2" class="text-very-muted text-center text-lg">None</td>
											</tr></template>
											<template v-for="(f, j) in cat.otherFeedbacks">
												<tr :key="`provider-${j}`">
													<td colspan="2" class="text-left pl-3 text-md">
														<span :class="{ [`si-text-${getColor(i)}`]: true }"
															>{{
																f.provider
																	? fs.displayName(f.provider.name)
																	: "(Unknown)"
															}}'s</span
														>
														Assessment
														<button
															v-if="user.role == 'TEACHER'"
															class="mt-1 btn btn-no-border btn-si-icon float-right"
															v-tippy
															title="Delete"
														>
															<i class="fas fa-trash" @click="openDeleteModal(f)" />
														</button>
													</td>
												</tr>
												<tr :key="`result-${j}`">
													<td class="score-cell b-t b-r">{{ f.score }}</td>
													<td class="text-cell b-t text-left py-2 px-3">{{ f.text }}</td>
												</tr>
											</template>
										</table>
									</template>
								</div>
							</div>
						</template>
					</div>
				</div>
				<h1 v-if="!anyFeedbacks" class="text-center text-very-muted _800 mt-5 justify-self-center">
					No feedback
				</h1>
			</div>
		</div>

		<b-modal id="deleteFeedbackModal" headerClass="indigo">
			<template v-slot:modal-title>
				<h3 class="modal-title full-bar-title">Delete TVR Feedback</h3>
			</template>
			<div v-if="deletingFeedback" class="p-2">
				<div class="row px-4 py-2 text-md">
					<h5 class="py-2">
						Are you sure you want to delete these TVR Feedback responses from
						<strong class="text-theme text-center">{{ fs.displayName(deletingFeedback.provider.name) }}</strong>?
					</h5>
					<table>
						<tr>
							<td class="text-sm b-t b-r py-2 px-3">Score</td>
							<td class="text-sm b-t py-2 px-3">Text</td>
						</tr>
						<tr v-for="resp in deletingFeedback.response.responses" :key="resp.id">
							<td class="text-sm b-t b-r py-2 px-3">{{ resp.score }}</td>
							<td class="text-sm b-t py-2 px-3">{{ resp.text}}</td>
						</tr>
					</table>
					<h6 class="py-2">
						After deleting, the student will be able to re-submit their responses provided the assignment is still open.
					</h6>
					<h6 class="py-2">
						<span class="text-danger far faw fa-exclamation-triangle"></span>
						The operation will occur immediately and cannot be canceled or reversed!
					</h6>
					<h6 class="py-2">
						<span class="text-danger far faw fa-exclamation-triangle"></span>
						If you need to keep a record of these responses, export TVR data before deleting.
					</h6>
				</div>
				<div class="form-group pl-2 pr-3">
					<label>
						<input type="checkbox" v-model="deleteConfirm" />
						I have already exported TVR data OR no longer need access to these responses
					</label>
				</div>
			</div>
			<template v-slot:modal-footer="{ ok, cancel }">
				<button
					type="button"
					class="btn btn-secondary"
					@click="cancel()"
				>
					Cancel
				</button>
				<button
					type="button"
					class="btn btn-danger"
					:disabled="!deleteConfirm"
					@click="deleteFeedback(deletingFeedback, ok)"
				>
					Delete
				</button>
			</template>
		</b-modal>

		<template v-slot:footer>
			<div class="col-6 text-right">
				<a class="btn btn-si-secondary" href="#/tvr_feedbacks">Back</a>
			</div>
		</template>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";

import ProgramService from "@/services/ProgramService";
import SectionService from "@/services/SectionService";
import TVRService from "@/services/TVRService";
import AdminService from "@/services/AdminService";
import Notie from "@/services/NotieService";
import BB from "bluebird";
import fs from "@/services/FormatService";
import _ from "lodash";

export default {
	name: "TVRFeedback",

	props: ["user"],

	components: { MainPage },

	data() {
		let teamID = this.$route.params.teamID;
		let assignmentID = this.$route.params.assignmentID;
		let recipientID = this.$route.params.recipientID;

		return {
			fs: fs,
			teamID: teamID,
			assignmentID: assignmentID,
			recipientID: recipientID,
			studentMode: recipientID == "mine",

			context: null,
			program: null,
			team: null,
			assignment: null,
			rubric: null,
			feedbacks: null,
			recipient: null,

			deletingFeedback: null,
			deleteConfirm: false,
		};
	},

	created() {
		this.loadData();
	},

	computed: {
		anyFeedbacks() {
			if (!this.feedbacks) return false;
			return this.feedbacks.length > 0;
		},
	},

	methods: {
		loadData() {
			let feedbackCall = TVRService.getReceivedFeedbacks(this.assignmentID, this.recipientID);
			if (this.studentMode) {
				feedbackCall = TVRService.getMyReceivedFeedbacks(this.assignmentID);
			}

			BB.props({
				program: ProgramService.getContextProgram(),
				context: SectionService.getContextPrefilled(),
				feedbacks: feedbackCall,
			})
				.then((r) => {
					this.program = r.program.data;
					this.context = r.context.data;
					this.team = _.find(this.context.teams, { id: this.teamID });
					this.assignment = _.find(this.context.tvrs, { id: this.assignmentID });
					if (
						this.user.role == "STUDENT" && this.assignment.hide_feedback ||
						this.user.role == "PARTNER" && !this.assignment.show_feedback_partner
					) {
						Notie.error("Feedback has been hidden by teacher")
					} else {
						this.feedbacks = r.feedbacks.data;

						this.rubric = this.program && this.program.tvr_config && this.program.tvr_config.rubric;
						this.rubricCategories = this.rubric ? this.rubric.categories : [];
						_.each(this.rubricCategories, (cat, i) => {
							this.$set(cat, "expanded", false);
							cat.color = this.getColor(i);
						});

						this.constructFeedback();
					}
				})
				.catch((e) => {
					console.log(e);
					Notie.error("Failed to load Team Value Rubric", e);
				});

			AdminService.getUser(this.recipientID)
			.then((r) => {
				this.recipient = r.data;
			})
			.catch(() => {
				this.recipient = null;
			});
		},

		constructFeedback() {
			_.each(this.rubric.categories, (cat) => {
				console.log("category", cat);
				let ownFeedback = null;
				let otherFeedbacks = [];

				_.each(this.feedbacks, (f) => {
					console.log("FEEDBACK", f);
					let resp = _.find(f.response.responses, { category_id: cat.id });
					resp.provider = f.provider;
					console.log("COMPARE IDS", f.provider_id, this.user.id);
					if (f.provider_id == this.user.id && this.studentMode || f.provider_id == this.recipientID) {
						ownFeedback = resp;
					} else if (resp) {
						otherFeedbacks.push(resp);
					}
				});

				cat.ownFeedback = ownFeedback;
				cat.otherFeedbacks = otherFeedbacks;
			});
		},

		getColor(index) {
			if (index % 2 == 1) {
				return "green";
			}
			if (index % 4 == 0) {
				return "orange";
			}
			if (index % 4 == 2) {
				return "yellow";
			}
		},

		openDeleteModal(feedback) {
			this.deletingFeedback = _.filter(this.feedbacks, (f) => {
				return f.provider_id == feedback.provider.id
			})[0];
			this.deleteConfirm = false;
			this.$bvModal.show("deleteFeedbackModal");
		},

		deleteFeedback(tvr) {
			TVRService.deleteFeedback(tvr.id)
				.then(() => {
					Notie.success("Successfully deleted");
					this.loadData();
					this.$bvModal.hide("deleteFeedbackModal");
					this.deletingFeedback = null;
					this.deleteConfirm = false;
				})
				.catch((e) => {
					console.log(e);
					Notie.error("Failed to delete TVR", e);
				});
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	margin-bottom: 3rem;
}
.content .col-12 {
	margin-top: 3rem;
}

.h-pad {
	padding: 0rem 2rem;
}

.sticky {
	position: -webkit-sticky;
	position: sticky;
	top: 3rem;
	height: 0px;
	width: 100%;
	z-index: 2;
}

.instructions {
	display: block;
	top: 0;
	margin-left: calc(50% - 640px);
	width: 1280px;
	transition: margin-left 0.5s ease-in-out, width 0.5s ease-in-out;
}
.instructions.instructions-right {
	margin-left: calc(50% + 80px);
	width: 560px;
	height: 315px;
}

.feedback {
	display: block;
	width: 700px;
	margin-left: calc(50% - 640px);
	margin-right: 580px;
	transition: opacity 0.5s;
}

textarea {
	border-width: 2px !important;
	border-color: rgb(200, 200, 200) !important;
}

.v-mid {
	vertical-align: middle;
}

td {
	padding-top: 0.25rem;
	padding-bottom: 0.25rem;
}

.score-cell {
	width: 50px;
	height: 40px;
	font-size: 24px;
}
</style>
